@if (type === 'radio') {
  <div class="radio-container">
    <label [for]="inputId" class="radio-label">{{ label }}</label>
    <input
      [disabled]="isDisabled"
      [ngClass]="{ disabled: isDisabled }"
      [attr.id]="inputId"
      class="radio-input {{ extraClass }}"
      type="radio"
      [(ngModel)]="fieldValue"
      [name]="name"
      (ngModelChange)="changeFieldValue()"
      [value]="radioValue"
      (blur)="onBlur()" />
  </div>
} @else {
  <input
    [disabled]="isDisabled"
    [ngClass]="{ disabled: isDisabled }"
    [attr.id]="inputId"
    [ngClass]="isWrong ? 'input-text input-text--is-wrong' : 'input-text'"
    class="input-text {{ classes }} {{ extraClass }}"
    [type]="type"
    [placeholder]="placeholder"
    [(ngModel)]="fieldValue"
    (ngModelChange)="changeFieldValue()"
    [maxlength]="maxLength"
    (keydown)="emitValue($event)"
    (blur)="onBlur()" />
  <input
    *ngIf="type === 'date'"
    type="text"
    appDateFormat
    [placeholder]="placeholder"
    [(ngModel)]="fieldValue"
    (ngModelChange)="changeFieldValue()"
    [maxlength]="maxLength" />
  <p class="error-text" *ngIf="showError && isWrong">
    <img src="../../../../assets/icons/Alert.svg" alt="Alert svg red" />
    {{ showError }}
  </p>
}
